import moment from 'moment'
import React, { useState } from 'react'
import Tooltip from '@mui/material/Tooltip';
import { Modal } from 'react-bootstrap';
import ApiService from "../../api/ApiService";
import { useForm } from "react-hook-form";
import notification from "../../helpers/notification";

const NityasevaTableRow = ({ nityaseva, onStatusUpdate }) => {
  const [isDialogViewOpen, setIsDialogViewOpen] = useState(false);
  const [dialogdata, setDialogdata] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [sub_id, setSubid] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1) : '';

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm();

   const selectedReason = watch("cancelReason"); // Watch the selected value

  const handleModalView = async (id, frequency, start_date, end_date, status, sub_id) => {
    const data = [id, frequency, start_date, end_date, status, sub_id];
    setDialogdata(data);
    setIsDialogViewOpen(true);
  };

  const handleModal = (sub_id) => {
    setSubid(sub_id);
    setIsDialogOpen(true);
  };

  const handleNityaSeva = async (data) => {
    try {
      setIsLoading(true);
      const response = await ApiService.nityaSevaCancel({
        cancelReason: data.cancelReason,
        sub_id: sub_id,
      });

      if (response) {
        notification('success', 'Nitya Seva cancelled successfully');
        reset();
        setIsDialogOpen(false);
        // Trigger parent component to refresh data
        if (onStatusUpdate) {
          onStatusUpdate();
        }
      }
    } catch (error) {
      notification('error', 'Failed to cancel Nitya Seva');
      console.error('Error cancelling Nitya Seva:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // const handleNityaSevaPause = async (id) => {
  //   try {
  //     alert()
  //     setIsLoading(true);
  //     const valuesArray = id.split(',');

  //     const response = await ApiService.nityaSevaPause({
  //       type: valuesArray[1],
  //       sub_id: valuesArray[0],
  //     });

  //     if (response?.status === 'paused') {
  //       notification('success', 'Your subscription has been paused');
  //     }
  //     if (response?.status === 'active') {
  //       notification('success', 'Your subscription has been resumed');
  //     }

  //     reset();
  //     setIsDialogViewOpen(false);

  //     // Trigger parent component to refresh data
  //     if (onStatusUpdate) {
  //       onStatusUpdate();
  //     }
  //   } catch (error) {
  //     notification('error', 'Failed to update subscription status');
  //     console.error('Error updating subscription:', error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleNityaSevaPause = async (id) => {
  const valuesArray = id.split(',');
  const type = valuesArray[1];

  // Determine action label based on current status
  const action = type === 'hold' ? 'pause' : 'resume';

  const confirmAction = window.confirm(`Are you sure you want to ${action} your subscription?`);
  if (!confirmAction) return;

  try {
    setIsLoading(true);

    const response = await ApiService.nityaSevaPause({
      type,
      sub_id: valuesArray[0],
    });

    if (response?.status === 'paused') {
      notification('success', 'Your subscription has been paused');
    }
    if (response?.status === 'active') {
      notification('success', 'Your subscription has been resumed');
    }

    reset();
    setIsDialogViewOpen(false);

    if (onStatusUpdate) {
      onStatusUpdate();
    }
  } catch (error) {
    notification('error', 'Failed to update subscription status');
    console.error('Error updating subscription:', error);
  } finally {
    setIsLoading(false);
  }
};


  const closeDialog = () => {
    setIsDialogOpen(false);
    reset();
  };

  const closeDialogView = () => {
    setDialogdata([]);
    setIsDialogViewOpen(false);
  };

  const subscription = nityaseva?.subscription;
  const isActive = subscription?.status === "active";
  const isPaused = subscription?.status === "paused";
  const isCancelled = subscription?.status === "cancelled";

  return (
    <div className="row align-items-center py-3">
      <div className="col-lg-2">
        <div className="form-field">
          <h5 className="form-title">Date :</h5>
          <p id="donation-date">
            {moment(nityaseva?.donation_date).format("DD/MM/YYYY")}
          </p>
        </div>
      </div>

      <div className="col-lg-2">
        <div className="form-field">
          <h5 className="form-title">Purpose :</h5>
          <p id="donation-date">{nityaseva?.scheme_type?.name}</p>
        </div>
      </div>

      <div className="col-lg-2">
        <div className="form-field">
          <h5 className="form-title">Status :</h5>
          <p
            id="donation-status"
            className={`text-uppercase ${isActive ? 'text-success' : isPaused ? 'text-warning' : 'text-danger'}`}
          >
            {capitalize(subscription?.status)}
          </p>
        </div>
      </div>

      <div className="col-lg-2">
        <div className="form-field">
          <h5 className="form-title">Name :</h5>
          <p id="donation-name">{nityaseva?.donor_name}</p>
        </div>
      </div>

      <div className="col-lg-2">
        <div className="form-field">
          <h5 className="form-title">Amount :</h5>
          <p id="donation-amount">₹{nityaseva?.amount}</p>
        </div>
      </div>

      <div className="col-lg-2">
        <div className="form-field">
          <h5 className="form-title">Action :</h5>
          <div className="d-flex gap-2">
            <Tooltip title="View details" placement="bottom-start">
              <button
                onClick={() => handleModalView(
                  subscription?.id,
                  subscription?.frequency,
                  subscription?.start_date,
                  subscription?.end_date,
                  subscription?.status,
                  subscription?.sub_id
                )}
                className="btn btn-outline-dark btn-sm"
                disabled={isLoading}
              >
                VIEW
              </button>
            </Tooltip>

            {!isCancelled && (
              <Tooltip title="Cancel Nitya Seva Donation" placement="bottom-start">
                <button
                  onClick={() => handleModal(subscription?.sub_id)}
                  className="btn btn-outline-danger btn-sm"
                  disabled={isLoading}
                >
                  CANCEL
                </button>
              </Tooltip>
            )}
          </div>
        </div>
      </div>

      {/* Cancel Modal */}
      <Modal centered show={isDialogOpen} onHide={closeDialog}>
        <Modal.Header closeButton>
          <Modal.Title>Cancel Nitya Seva</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(handleNityaSeva)}>
            <div className="row">
              <div className="col-md-5 col-sm-12">
                <div className="mb-3">
                  <label htmlFor="cancelReason" className="form-label">
                    We truly respect your decision. If you're comfortable sharing, may we kindly know the reason for the cancellation? It would help us improve and serve you better in the future. <span className="text-danger">*</span>
                  </label>

                </div>
              </div>
              <div className="label-input-wrap col-md-5 col-sm-12">
      <select
        className="form-control"
        id="cancelReason"
        {...register("cancelReason", {
          required: "Cancellation reason is required",
        })}
      >
        <option value="">Select a reason...</option>
        <option value="Switched to manual donations">Switched to manual donations</option>
        <option value="Temporary pause">Temporary pause</option>
        <option value="Completed My Intended Contribution Period">Completed My Intended Contribution Period</option>
        <option value="Technical Issues with the Auto-Debit System">Technical Issues with the Auto-Debit System</option>
        <option value="Lack of Communication or Updates">Lack of Communication or Updates</option>
        <option value="Unaware of Auto-Debit Enrollment">Unaware of Auto-Debit Enrollment</option>
        <option value="Financial Constraints">Financial Constraints</option>
        <option value="Others (Specify)">Others</option>
      </select>

      {errors.cancelReason && (
        <div className="text-danger mt-1">{errors.cancelReason.message}</div>
      )}

      {/* Show input only when "Others (Specify)" is selected */}
      {selectedReason === "Others (Specify)" && (
        <input
          type="text"
          className="form-control mt-2"
          placeholder="Please specify your reason"
          {...register("otherReason", {
            required: "Please specify your reason",
            minLength: {
              value: 5,
              message: "Please enter at least 5 characters",
            },
          })}
        />
      )}

      {/* Validation error for the conditional input */}
      {selectedReason === "Others (Specify)" && errors.otherReason && (
        <div className="text-danger mt-1">{errors.otherReason.message}</div>
      )}
    </div>
            </div>


            <div className="d-flex justify-content-end gap-2 mt-3">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={closeDialog}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-danger"
                disabled={isLoading}
              >
                {isLoading ? 'Submitting...' : 'Submit Cancellation'}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      {/* View Details Modal */}
      <Modal centered show={isDialogViewOpen} onHide={closeDialogView} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Nitya Seva Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <div className="row mb-3">
              <div className="col-4"><strong>Subscription ID:</strong></div>
              <div className="col-8">{dialogdata[5]}</div>
            </div>

            <div className="row mb-3">
              <div className="col-4"><strong>Frequency:</strong></div>
              <div className="col-8">{dialogdata[1]}</div>
            </div>

            <div className="row mb-3">
              <div className="col-4"><strong>Start Date:</strong></div>
              <div className="col-8">{moment(dialogdata[2]).format("DD/MM/YYYY")}</div>
            </div>

            <div className="row mb-3">
              <div className="col-4"><strong>End Date:</strong></div>
              <div className="col-8">{moment(dialogdata[3]).format("DD/MM/YYYY")}</div>
            </div>

            <div className="row mb-3">
              <div className="col-4"><strong>Status:</strong></div>
              <div className="col-8">
                <div className="d-flex align-items-center gap-3">
                  <span
                    className={`badge ${dialogdata[4] === "active" ? 'bg-success' :
                        dialogdata[4] === "paused" ? 'bg-warning' :
                          'bg-danger'
                      }`}
                  >
                    {capitalize(dialogdata[4])}
                  </span>

                  {isActive && (
                    <Tooltip title="Pause Nitya Seva Donation" placement="top">
                      <button
                        onClick={() => handleNityaSevaPause(dialogdata[5] + ',hold')}
                        className="btn btn-warning btn-sm badge"
                        disabled={isLoading}
                      >
                        {isLoading ? 'Processing...' : 'Pause'}
                      </button>
                    </Tooltip>
                  )}

                  {isPaused && (
                    <Tooltip title="Resume Nitya Seva Donation" placement="top">
                      <button
                        onClick={() => handleNityaSevaPause(dialogdata[5] + ',start')}
                        className="btn btn-success btn-sm badge"
                        disabled={isLoading}
                      >
                        {isLoading ? 'Processing...' : 'Resume'}
                      </button>
                    </Tooltip>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default NityasevaTableRow;